"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Strings = require("../core/Strings");

var _MeasureText = require("../utils/MeasureText");

var _UITextArea = _interopRequireDefault(require("./UITextArea"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var xxlSizeMixin = (0, _styledComponents.css)(["font-size:32px;line-height:40px;padding:16px;"]);

var getSize = function getSize(_ref) {
  var size = _ref.size;
  return size === 'xxl' && xxlSizeMixin;
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "UIMatchTextArea__Wrapper",
  componentId: "edshwy-0"
})(["position:relative;width:100%;"]);

var PlaceholderText = _styledComponents.default.div.withConfig({
  displayName: "UIMatchTextArea__PlaceholderText",
  componentId: "edshwy-1"
})(["&&{border-color:transparent;color:", ";position:relative;word-wrap:break-word;", "}"], _colors.EERIE, getSize);

var TextArea = (0, _styledComponents.default)(_UITextArea.default).withConfig({
  displayName: "UIMatchTextArea__TextArea",
  componentId: "edshwy-2"
})(["&&{background-color:transparent;left:0;position:absolute;top:0;width:100%;", "}"], getSize);

var UIMatchTextArea = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UIMatchTextArea, _Component);

  function UIMatchTextArea(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIMatchTextArea);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIMatchTextArea).call(this, props));

    _this.computeMatchTextHeight = function () {
      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
          _assertThisInitialize2 = _assertThisInitialize.props,
          inputRef = _assertThisInitialize2.inputRef,
          match = _assertThisInitialize2.match;

      var inputEl = inputRef.current;
      if (!inputEl) return;
      var originalInputValue = inputEl.value;
      inputEl.value = match;
      var matchTextHeight = (0, _MeasureText.getTextHeight)(inputEl);
      inputEl.value = originalInputValue;

      if (matchTextHeight !== _this.state.matchTextHeight) {
        _this.setState({
          matchTextHeight: matchTextHeight
        });
      }
    };

    _this.handleChange = function (evt) {
      var _assertThisInitialize3 = (0, _assertThisInitialized2.default)(_this),
          _assertThisInitialize4 = _assertThisInitialize3.props,
          match = _assertThisInitialize4.match,
          matched = _assertThisInitialize4.matched,
          onChange = _assertThisInitialize4.onChange,
          onMatchedChange = _assertThisInitialize4.onMatchedChange;

      var value = evt.target.value;

      if (!(0, _Strings.inputCouldMatch)(value, match)) {
        return;
      }

      onChange(evt);
      var newMatched = value === match;

      if (newMatched !== matched) {
        onMatchedChange((0, _SyntheticEvent.default)(newMatched));
      }
    };

    _this.state = {
      matchTextHeight: null
    };
    return _this;
  }

  (0, _createClass2.default)(UIMatchTextArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Handle case where initial "value" and "match" props are equal.
      var _this$props = this.props,
          match = _this$props.match,
          onMatchedChange = _this$props.onMatchedChange,
          value = _this$props.value;

      if (value === match) {
        onMatchedChange((0, _SyntheticEvent.default)(value === match));
      }

      this.computeMatchTextHeight();
      addEventListener('resize', this.computeMatchTextHeight);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.match !== this.props.match) {
        this.computeMatchTextHeight();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeEventListener('resize', this.computeMatchTextHeight);
    }
    /**
     * Measure the match text to determine the height of the <textarea>.
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          inputClassName = _this$props2.inputClassName,
          match = _this$props2.match,
          __matched = _this$props2.matched,
          __onChange = _this$props2.onChange,
          __onMatchedChange = _this$props2.onMatchedChange,
          size = _this$props2.size,
          value = _this$props2.value,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "inputClassName", "match", "matched", "onChange", "onMatchedChange", "size", "value"]),
          matchTextHeight = this.state.matchTextHeight;
      var style = {
        height: matchTextHeight
      };
      return _react.default.createElement(Wrapper, {
        className: className
      }, _react.default.createElement(PlaceholderText, {
        style: style,
        size: size,
        className: "form-control private-form__control"
      }, match), _react.default.createElement(TextArea, Object.assign({}, rest, {
        className: inputClassName,
        size: size,
        "data-match-value": match,
        value: value,
        onChange: this.handleChange,
        resize: false,
        style: style
      })));
    }
  }]);
  return UIMatchTextArea;
}(_react.Component);

UIMatchTextArea.displayName = 'UIMatchTextArea';
UIMatchTextArea.propTypes = Object.assign({}, _UITextArea.default.propTypes, {
  inputClassName: _propTypes.default.string,
  match: _propTypes.default.string,
  matched: _propTypes.default.bool,
  onMatchedChange: _propTypes.default.func.isRequired,
  size: _propTypes.default.oneOf(['md', 'xxl'])
});
UIMatchTextArea.defaultProps = Object.assign({}, _UITextArea.default.defaultProps, {
  matched: false
});

var _default = (0, _ShareInput.default)((0, _Controllable.default)(UIMatchTextArea, ['matched', 'value']));

exports.default = _default;
module.exports = exports.default;